import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from 'debug'
import {DokumentsigneringRessurs} from "felles/tjenester/ressurser/DokumentsigneringRessurs";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {DokumentRessurs} from "../../../../../felles/tjenester/ressurser/DokumentRessurs";
import {gettextCatalog} from "angular-gettext";

const debug: Debugger = require('debug')('SendPåminelseOmSigneringDialog');
const css = require('./sendPåminelseOmSigneringDialog.scss');

export class SendPåminelseOmSigneringDialog implements MdDialogController {

    static visSendPåminelseOmSigneringDialog(dokumentId: string, $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon({dokumentId: dokumentId}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./sendPåminelseOmSigneringDialog.html'),
            controller: SendPåminelseOmSigneringDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            DokumentRessurs.regNavn,
            DokumentsigneringRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            SendPåminelseOmSigneringDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private dokumentRessurs: DokumentRessurs,
                private dokumentsigneringRessurs: DokumentsigneringRessurs,
                private gettextCatalog: gettextCatalog) {
    }

    dokumentId: string; //settes via bindings

    modus: 'skjema' | 'kvittering' = 'skjema';
    signatarer: l.DokumentSignatarerModell;
    dokument: l.DokumentVersjonModell;
    harIkkeSignert: l.DokumentSignatarModell[];
    beskjed: string;
    lagrer = false;
    antallSendt: number;


    purringSendeOmAntallDager(){
        if (!this.signatarer) return '';
        return this.signatarer.dagerTilNestePurring == 0 ?
          this.gettextCatalog.getString('i dag') :
          this.gettextCatalog.getString('om {{antall}} dager', {antall: this.signatarer.dagerTilNestePurring});
    }

    send() {
        this.lagrer = true;
        return this.dokumentsigneringRessurs.sendPurring(this.dokumentId, this.beskjed).$promise
          .then(antall => {
              this.modus = 'kvittering';
              this.antallSendt = antall.antall;
          })
          .finally(() => this.lagrer = false);
    }

    ferdig(){
        this.$mdDialog.hide(true);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        this.dokumentsigneringRessurs.signatarer(this.dokumentId).$promise
            .then(signatarer => this.initSignatarer(signatarer));
        this.dokumentRessurs.hentGjeldendeDokumentversjon(this.dokumentId).$promise
          .then(dokument => this.dokument = dokument);
    }

    //hjelpemetoder

    private initSignatarer(signatarer: l.DokumentSignatarerModell){
        this.signatarer = signatarer;
        this.harIkkeSignert = signatarer.signatarer.filter(s => !s.harSignert)
    }

}
